<ul class="list-group custom-code-list" #codeDraggableTokenList>
  <ng-container *ngFor="let item of items$ | async">
    <li
      class="list-group-item custom-code-item"
      #codeItem
      [class.selected]="selectedField === codeItem"
      (click)="select.emit(codeItem)"
      *ngIf="getDataTokenDef | call : dataDicHelper : item as token"
      [ngClass]="signFieldManager.draggableElementClass"
      [attr.data-type]="'datadic'"
      [attr.data-key]="token.key"
      [attr.data-field]="token.field"
      [attr.data-data-type]="token.type"
      [attr.data-label]="token.label"
    >
      <div class="custom-code-name text-truncate" [matTooltip]="item.name + ':' + item.rentalNames">
        {{ item.name }}
        <span *ngIf="item.rentalNames">: {{ item.rentalNames }}</span>
      </div>

      <a
        class="drag-hidden edit-custom-btn"
        i18n-matTooltip
        matTooltip="Click here to edit this custom code."
        (click)="onEdit(item)"
      >
        <i class="far fa-pencil"></i>
      </a>
    </li>
  </ng-container>
</ul>
<button class="btn btn-secondary-info mt-3" type="button" (click)="onAdd()">
  <span class="far fa-plus"></span>
  <ng-container i18n>Add Custom Code</ng-container>
</button>
